import React from "react"
import { I18nContext } from "./src/context/I18nContext"
import "../../node_modules/@yumgmbh/gatsby-theme-yum-components/src/scss/style.scss"
import { NexmartCartContextProvider } from "./src/context/NexmartCartContext"

require("typeface-inter")

const wrapPageElement = ({ element, props }) => {
  return (
    <I18nContext pageContext={props.pageContext}>
      <NexmartCartContextProvider pageContext={props.pageContext}>
        {element}
      </NexmartCartContextProvider>
    </I18nContext>
  )
}

export { wrapPageElement }

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.NODE_ENV === `production` || `development`) {
    setTimeout(() => {
      if (window && window.ga) {
        window.ga("set", "page", location.pathname)
        window.ga("send", "pageview")
      }
    }, 50)
  }
}
